export const maxSquareCalculator = (
  faces: any[],
  gravityCenter,
  ratio,
  containerRatio = 1
) => {
  return faces.length === 0 ||
    (Math.floor(ratio) === Math.floor(containerRatio) &&
      Math.abs(ratio - containerRatio) < 0.3)
    ? containerRatio > ratio
      ? {
          w: 100,
          x: 0,
          h: (ratio / containerRatio) * 100,
          y: (100 - (ratio / containerRatio) * 100) / 2,
        }
      : {
          h: 100,
          y: 0,
          w: (containerRatio / ratio) * 100,
          x: (100 - (containerRatio / ratio) * 100) / 2,
        }
    : ((gravityCenter) => {
        const xCenter =
          gravityCenter[0] + (gravityCenter[2] - gravityCenter[0]) / 2;
        const yCenter =
          gravityCenter[1] + (gravityCenter[3] - gravityCenter[1]) / 2;

        if (containerRatio > 1) {
          const imageWidth = 100;
          const imageHeight = imageWidth / ratio;
          const containerWidth = 100;
          const containerHeight = containerWidth / containerRatio;
          const result = [
            xCenter * imageWidth - 1,
            yCenter * imageHeight - 1,
            xCenter * imageWidth + 1,
            (yCenter * imageHeight) / containerRatio + 1,
          ];
          while (
            result[0] > 0 &&
            result[1] > 0 &&
            result[2] < containerWidth &&
            result[3] < containerHeight
          ) {
            result[0] -= 1;
            result[1] -= 1;
            result[2] += 1;
            result[3] += 1;
            console.log(result);
          }
          console.log(result);
          return {
            x: 0,
            y: Math.min(
              Math.abs(result[1] / imageHeight) * 100,
              100 - (100 / containerRatio) * ratio
            ),
            w: 100,
            h: (100 / containerRatio) * ratio,
          };
        }
        if (containerRatio < 1) {
          const imageWidth = 100;
          const imageHeight = imageWidth / ratio;
          const containerWidth = 100;
          const containerHeight = containerWidth / containerRatio;
          const result = [
            xCenter * imageWidth - containerRatio,
            yCenter * imageHeight - 1,
            xCenter * imageWidth + containerRatio,
            yCenter * imageHeight + 1,
          ];
          console.log((result[2] - result[0]) / (result[3] - result[1]));

          while (
            result[0] > 0 &&
            result[1] >= 0 &&
            result[2] < containerWidth &&
            result[3] < containerHeight &&
            result[2] < imageWidth &&
            result[3] < imageHeight
          ) {
            result[0] -= containerRatio / 2;
            result[1] -= 1 / 2;
            result[2] += containerRatio / 2;
            result[3] += 1 / 2;

            if (
              result[0] > 0 &&
              result[1] <= 0 &&
              result[2] < containerWidth &&
              result[3] < containerHeight &&
              result[2] < imageWidth &&
              result[3] < imageHeight
            ) {
              result[1] = 0;
              result[3] += 1 / 2;
            }
          }
          console.log((result[2] - result[0]) / result[3] - result[1]);
          console.log(result);
          return {
            x: Math.min(
              100 - (containerRatio * 100) / ratio,
              Math.abs(result[0] / imageWidth) * 100
            ),
            y: 0,
            w: (containerRatio * 100) / ratio,
            h: 100,
          };
        }

        const imageWidth = 100;
        const imageHeight = imageWidth / ratio;
        const result = [
          xCenter * imageWidth - 1,
          yCenter * imageHeight - 1,
          xCenter * imageWidth + 1,
          yCenter * imageHeight + 1,
        ];
        while (
          result[0] > 0 &&
          result[1] > 0 &&
          result[2] < imageWidth &&
          result[3] < imageHeight
        ) {
          result[0] -= 1;
          result[1] -= faces.length === 1 ? 0.75 : 0.85;
          result[2] += 1;
          result[3] += faces.length === 1 ? 1.25 : 1.15;
        }
        console.log(result);
        return {
          x: Math.abs(result[0] / imageWidth) * 100,
          y: Math.abs(result[1] / imageHeight) * 100,
          w: ((result[2] - result[0]) / imageWidth) * 100,
          h: ((result[3] - result[1]) / imageHeight) * 100,
        };
      })(gravityCenter);
};
